import {
  addFinancingCommitment as addFinancingCommitmentProtocol,
  addResearcher as addResearcherProtocol,
  assignResearchLine as assignResearchLineToProtocol,
  cancelProtocol as requestCancelProtocol,
  cancelResearcherInvitation,
  cancelExternalResearcherInvitation,
  completeFinancinCommitment as completeCommitment,
  completeFinancingExtensionCommitment as completeExtensionCommitment,
  deleteProtocol as requestDeleteProtocol,
  dictateDeleteCommitment as dictateDeleteProtocolCommitment,
  dictateDeleteFinancingExtensionCommitment as dictateDeleteAmendmentFinancingExtensionCommitment,
  editFinancingCommitment as editFinancingCommitmentProtocol,
  fetchBiosecurityQuestionnaire,
  fetchEthicsRenewalAttachments,
  fetchEthicsRenewalDictums,
  fetchFinancingCommitment,
  fetchFinancingCommitments,
  fetchFunderInstitutions,
  fetchFunderOrigins,
  fetchProtocolAdvances,
  fetchProtocolAdverseEvents,
  fetchProtocolAttachments,
  fetchProtocolCommitteeAssignedReviewers,
  fetchProtocolCommitteeDictums,
  fetchProtocolCommitteeMeetingDates,
  fetchProtocolFinalReports,
  fetchProtocolLeaderEvaluation,
  fetchProtocoloEvaluations,
  fetchProtocoloFunders,
  fetchProtocolPendingTasks,
  fetchProtocolRenewals,
  fetchResearchers,
  fetchResearchLines,
  fetchRPBIResearchers,
  inviteResearchersByEmail,
  reinviteResearcher as reinviteResearcherAgain,
  reinviteExternalResearcher as reinviteProtocolExternalResearcher,
  rejectResearcherInvitation as rejectInvitation,
  removeAmendmentFile as removeFileFromAmendment,
  removeCommitment as removeProtocolCommitment,
  removeEthicsAttachment,
  removeFunder as removeFunderFromProtocol,
  removeProtocolAttachment as removeAttachmentFromProtocol,
  removeProtocolFile as removeFileFromProtocol,
  removeResearchLine as removeResearchLineFromProtocol,
  requestDeleteCommitment as requestDeleteProtocolCommitment,
  requestDeleteFinancingExtensionCommitment as requestAmendmentDeleteFinancingExtensionCommitment,
  requestRemoveCommitment,
  requestRemoveExtensionCommitment,
  rescheduleFinancinCommitment as rescheduleCommitment,
  rescheduleFinancingExtensionCommitment as rescheduleExtensionCommitment,
  resendResearcherNotification,
  respondProtocolConditionedEvaluation,
  saveAmendmentFile as saveFileInAmendment,
  saveBiosecurityQuestionnaire as saveQuestionnaire,
  saveEthicsAttachments,
  saveEthicsRenewalDictum as saveRenewalDictum,
  saveEthicsRenewalFormat as saveEthicsFormat,
  saveFinalReportDictum as saveFinalReport,
  saveFinancingInformation,
  saveFunderAgreement,
  saveFunders,
  saveProtocolAdvances as saveAdvance,
  saveProtocolAttachments as saveAttachments,
  saveProtocolFile as saveFileInProtocol,
  saveUCPCodeProtocol,
  sendDirectorEvaluation,
  sendLeaderEvaluation,
  sendProtocolToDevelopment,
  sendProtocolToEvaluationByLeader,
  sendReplyToProtocol,
  updateCompletedFinancinCommitment as updateCompletedCommitment,
  updateCompletedFinancingExtensionCommitment as updateCompletedExtensionCommitment,
  updateDictumFile,
  updateFinalReport as updateProtocolFinalReport,
  updateFunderInformation as updateFunder,
  updateProtocolRealDates as updateRealDates,
  updateRescheduledFinancinCommitment as updateRescheduledCommitment,
  updateRescheduledFinancingExtensionCommitment as updateRescheduledExtensionCommitment,
  validateProtocolDevelopmentRequest as validateProtocolDevRequest,
  saveRequestedFunder as saveRequestedFunderInServer,
  resendExternalResearcherNotification,
} from './api'

const sendInviteReply = async({ commit }, payload) => {
  try {
    return await sendReplyToProtocol(payload)
  } catch (e) {
    console.error(e)
  }
}

const resendInvitationNotification = async({ commit }, payload) => {
  try {
    return await resendResearcherNotification(payload)
  } catch (e) {
    console.error(e)
  }
}

const resendExternalInvitationNotification = async({ commit }, payload) => {
  try {
    return await resendExternalResearcherNotification(payload)
  } catch (e) {
    console.error(e)
  }
}

const reinviteResearcher = async({ commit }, payload) => {
  try {
    const response = await reinviteResearcherAgain(payload)
    
    commit('SET_PROTOCOL_RESEARCHERS', response.data.data.researchers)

    commit('SET_PROTOCOL_EXTERNAL_RESEARCHERS', response.data.data.external_researchers)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const reinviteExternalResearcher = async({ commit }, payload) => {
  try {
    const response = await reinviteProtocolExternalResearcher(payload)
    
    commit('SET_PROTOCOL_EXTERNAL_RESEARCHERS', response.data.data.external_researchers)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const addResearcher = async({
  commit,
  state,
}, payload) => {
  try {
    const response = await addResearcherProtocol(payload)
    
    commit('SET_PROTOCOL_RESEARCHERS', response.data.data.researchers)
    
    commit('SET_PROTOCOL_EXTERNAL_RESEARCHERS', response.data.data.external_researchers)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const saveLeaderEvaluation = async({ commit }, payload) => {
  try {
    return await sendLeaderEvaluation(payload)
  } catch (e) {
    console.error(e)
  }
}

const getProtocolLeaderEvaluation = async({ commit }, protocol) => {
  try {
    return await fetchProtocolLeaderEvaluation(protocol)
  } catch (e) {
    console.error(e)
  }
}

const saveDirectorEvaluation = async({ commit }, payload) => {
  try {
    return await sendDirectorEvaluation(payload)
  } catch (e) {
    console.error(e)
  }
}

const sendProtocolToEvaluation = async({ commit }, protocol) => {
  try {
    return await sendProtocolToEvaluationByLeader(protocol)
  } catch (e) {
    console.error(e)
  }
}

const respondConditioned = async({ commit }, payload) => {
  try {
    return await respondProtocolConditionedEvaluation(payload)
  } catch (e) {
    console.error(e)
  }
}

const removeResearcher = async({
  commit,
  state,
}, payload) => {
  try {
    const response = await cancelResearcherInvitation(payload)
    
    commit('SET_PROTOCOL_RESEARCHERS', response.data.data.researchers)

    commit('SET_PROTOCOL_EXTERNAL_RESEARCHERS', response.data.data.external_researchers)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const removeExternalResearcher = async({
  commit,
  state,
}, payload) => {
  try {
    const response = await cancelExternalResearcherInvitation(payload)
    
    commit('SET_PROTOCOL_EXTERNAL_RESEARCHERS', response.data.data.external_researchers)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const saveProtocolFile = async({ commit }, payload) => {
  try {
    const response = await saveFileInProtocol(payload)
    
    commit('SET_PROTOCOL_FILE', response.data.data.file)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const saveAmendmentFile = async({ commit }, payload) => {
  try {
    const response = await saveFileInAmendment(payload)
    
    commit('SET_AMENDMENT_FILE', response.data.data.file)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const removeProtocolFile = async({ commit }, protocol) => {
  try {
    const response = await removeFileFromProtocol(protocol)
    
    commit('SET_PROTOCOL_FILE', null)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const removeAmendmentFile = async({ commit }, file) => {
  try {
    const response = await removeFileFromAmendment(file)
    file.path      = null
    file.name      = null
    
    commit('SET_AMENDMENT_FILE', file)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const removeProtocolAttachment = async({ commit }, payload) => {
  try {
    const response = await removeAttachmentFromProtocol(payload)
    
    commit('SET_PROTOCOL_ATTACHMENTS', response.data.data.attachments)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const getProtocolAttachments = async({ commit }, protocol) => {
  try {
    const response = await fetchProtocolAttachments(protocol)
    
    commit('SET_PROTOCOL_ATTACHMENTS', response.data.data.attachments)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const saveProtocolAttachments = async({ commit }, payload) => {
  try {
    const response = await saveAttachments(payload)
    
    commit('SET_PROTOCOL_ATTACHMENTS', response.data.data.attachments)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const saveProtocolFinancing = async({ commit }, payload) => {
  try {
    const response = await saveFinancingInformation(payload)
    
    commit('SET_PROTOCOL_FINANCING_INFORMATION',
      response.data.data.financing_information)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const syncFunders = async({ commit }, payload) => {
  try {
    const response = await saveFunders(payload)
    
    commit('SET_PROTOCOL_FUNDERS', response.data.data.funders)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const removeFunder = async({ commit }, payload) => {
  try {
    const response = await removeFunderFromProtocol(payload)
    
    commit('UPDATE_PROTOCOL_FUNDERS', response.data.data.funders)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const attachAgreementToFunder = async({ commit }, payload) => {
  try {
    const response = await saveFunderAgreement(payload)
    
    commit('UPDATE_PROTOCOL_FUNDERS', response.data.data.funders)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const getResearchLines = async({ commit }, payload) => {
  try {
    const response = await fetchResearchLines(payload)
    
    commit('SET_RESEARCH_LINES', response.data.data.research_lines)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const assignResearchLine = async({ commit }, payload) => {
  try {
    const response = await assignResearchLineToProtocol(payload)
    
    commit('SET_PROTOCOL_RESEARCH_LINES', response.data.data.research_lines)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const removeResearchLine = async({ commit }, payload) => {
  try {
    const response = await removeResearchLineFromProtocol(payload)
    
    commit('SET_PROTOCOL_RESEARCH_LINES', response.data.data.research_lines)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const getProtocolFunders = async({ commit }, protocol) => {
  try {
    const response = await fetchProtocoloFunders(protocol)
    
    commit('UPDATE_PROTOCOL_FUNDERS', response.data.data.funders)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const requestProtocolDevelopment = async({ commit }, payload) => {
  try {
    return await sendProtocolToDevelopment(payload)
  } catch (e) {
    console.error(e)
  }
}

const updateProtocolRealDates = async({ commit }, payload) => {
  try {
    const response = await updateRealDates(payload)
    
    commit('UPDATE_PROTOCOL_DEVELOPMENT_REQUEST',
      response.data.data.development)
    
    return response
  } catch (e) {
    console.error(e)
  }
}

const validateProtocolDevelopmentRequest = async({ commit }, payload) => {
  try {
    return await validateProtocolDevRequest(payload)
  } catch (e) {
    console.error(e)
  }
}

const getFinancingCommitments = async({ commit }, protocol) => {
  try {
    const response = await fetchFinancingCommitments(protocol)
    
    commit('UPDATE_FINANCING_COMMITMENTS', response.data.data.commitments)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const getFinancingCommitment = async({ commit }, payload) => {
  try {
    const response = await fetchFinancingCommitment(payload)
    
    commit('UPDATE_FINANCING_COMMITMENTS', response.data.data.commitments)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const addFinancingCommitment = async({
  commit,
  state,
}, payload) => {
  try {
    const response = await addFinancingCommitmentProtocol(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const editFinancingCommitment = async({
  commit,
  state,
}, payload) => {
  try {
    const response = await editFinancingCommitmentProtocol(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const completeFinancinCommitment = async({ commit }, payload) => {
  try {
    return await completeCommitment(payload)
  } catch (e) {
    console.error(e)
  }
}

const rescheduleFinancinCommitment = async({ commit }, payload) => {
  try {
    return await rescheduleCommitment(payload)
  } catch (e) {
    console.error(e)
  }
}

const completeFinancingExtensionCommitment = async({ commit }, payload) => {
  try {
    return await completeExtensionCommitment(payload)
  } catch (e) {
    console.error(e)
  }
}

const rescheduleFinancingExtensionCommitment = async({ commit }, payload) => {
  try {
    return await rescheduleExtensionCommitment(payload)
  } catch (e) {
    console.error(e)
  }
}

const updateCompletedFinancingExtensionCommitment = async({ commit }, payload) => {
  try {
    return await updateCompletedExtensionCommitment(payload)
  } catch (e) {
    console.error(e)
  }
}

const updateRescheduledFinancingExtensionCommitment = async({ commit }, payload) => {
  try {
    return await updateRescheduledExtensionCommitment(payload)
  } catch (e) {
    console.error(e)
  }
}

const getProtocolResearchers = async({ commit }, payload) => {
  try {
    const response = await fetchResearchers(payload)
    
    commit('SET_PROTOCOL_RESEARCHERS', response.data.data.researchers)
    
    commit('SET_PROTOCOL_EXTERNAL_RESEARCHERS', response.data.data.external_researchers)
    
    return response
  } catch (e) {
    console.error(e)
  }
}

const renderBiosecurityQuestionnaire = async({ commit }, payload) => {
  try {
    return await fetchBiosecurityQuestionnaire(payload)
  } catch (e) {
    console.error(e)
  }
}

/**
 *
 * @param commit
 * @param payload
 * @returns {Promise<*|undefined>}
 */
const saveBiosecurityQuestionnaire = async({ commit }, payload) => {
  try {
    const response = await saveQuestionnaire(payload)
    
    if (response.data.data.status !== 'error') {
      commit('SET_BIOSECURITY_QUESTIONNAIRE', response.data.data.questionnaire)
      
    }
    
    return response
  } catch (e) {
    console.error(e)
  }
}

const removeCommitment = async({ commit }, payload) => {
  try {
    return (await removeProtocolCommitment(payload)).data.data
  } catch (e) {
    console.error(e)
  }
}

const dictateDeleteCommitment = async({ commit }, payload) => {
  try {
    return (await dictateDeleteProtocolCommitment(payload))
  } catch (e) {
    console.error(e)
  }
}

const dictateDeleteFinancingExtensionCommitment = async({ commit }, payload) => {
  try {
    return (await dictateDeleteAmendmentFinancingExtensionCommitment(payload))
  } catch (e) {
    console.error(e)
  }
}

const requestDeleteCommitment = async({ commit }, payload) => {
  try {
    return (await requestDeleteProtocolCommitment(payload))
  } catch (e) {
    console.error(e)
  }
}

const requestDeleteFinancingExtensionCommitment = async({ commit }, payload) => {
  try {
    return (await requestAmendmentDeleteFinancingExtensionCommitment(payload))
  } catch (e) {
    console.error(e)
  }
}

const rpbiResearchers = async({ commit }, payload) => {
  try {
    const response = await fetchRPBIResearchers(payload)
    
    commit('SET_RPBI_RESEARCHERS', response.data.data.researchers)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const sendInvitationByEmail = async({ commit }, payload) => {
  try {
    return await inviteResearchersByEmail(payload)
  } catch (e) {
    console.error(e)
  }
}

const rejectResearcherInvitation = async({ commit }, payload) => {
  try {
    return await rejectInvitation(payload)
  } catch (e) {
    console.error(e)
  }
}

const saveEthicsRenewalAttachments = async({ commit }, payload) => {
  try {
    const response = await saveEthicsAttachments(payload)
    
    commit('APPEND_ETHICS_RENEWAL_ATTACHMENTS', response.data.data.attachments)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const removeEthicsRenewalAttachment = async({ commit }, payload) => {
  try {
    const response = await removeEthicsAttachment(payload)
    
    commit('SET_ETHICS_RENEWAL_ATTACHMENTS', response.data.data.attachments)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const saveEthicsRenewalFormat = async({ commit }, payload) => {
  try {
    const response = await saveEthicsFormat(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const getEthicsRenewalAttachments = async({ commit }, payload) => {
  try {
    const response = await fetchEthicsRenewalAttachments(payload)
    
    commit('SET_ETHICS_RENEWAL_ATTACHMENTS', response.data.data.attachments)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const updateFunderInformation = async({ commit }, payload) => {
  try {
    const response = await updateFunder(payload)
    
    commit('SET_PROTOCOL_FUNDERS', response.data.data.funders)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const updateCompletedFinancinCommitment = async({ commit }, payload) => {
  try {
    return await updateCompletedCommitment(payload)
  } catch (e) {
    console.error(e)
  }
}

const updateRescheduledFinancinCommitment = async({ commit }, payload) => {
  try {
    return await updateRescheduledCommitment(payload)
  } catch (e) {
    console.error(e)
  }
}

const getEthicsRenewalDictums = async({ commit }, payload) => {
  try {
    return (await fetchEthicsRenewalDictums(payload)).data
  } catch (e) {
    console.error(e)
  }
}

const saveEthicsRenewalDictum = async({ commit }, payload) => {
  try {
    const response = await saveRenewalDictum(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const saveFinalReportDictum = async({ commit }, payload) => {
  try {
    const response = await saveFinalReport(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const updateFinalReport = async({ commit }, payload) => {
  try {
    const response = await updateProtocolFinalReport(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const requestRemoveFinacingCommitment = async({ commit }, payload) => {
  try {
    const response = await requestRemoveCommitment(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const requestRemoveFinacingExtensionCommitment = async({ commit }, payload) => {
  try {
    const response = await requestRemoveExtensionCommitment(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const cancelProtocol = async({ commit }, payload) => {
  try {
    const response = await requestCancelProtocol(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const getProtocolEvaluations = async(context, payload) => {
  try {
    return await fetchProtocoloEvaluations(payload)
  } catch (e) {
    console.log(e)
  }
}

const getProtocolCommitteeDictums = async(context, payload) => {
  try {
    return await fetchProtocolCommitteeDictums(payload)
  } catch (e) {
    console.error(e)
  }
}

const getProtocolPendingTasks = async(context, payload) => {
  try {
    return await fetchProtocolPendingTasks(payload)
  } catch (e) {
    console.error(e)
  }
}

const getProtocolCommitteeAssignedReviewers = async(context, payload) => {
  try {
    return await fetchProtocolCommitteeAssignedReviewers(payload)
  } catch (e) {
    console.error(e)
  }
}

const getProtocolCommitteeMeetingDates = async(context, payload) => {
  try {
    return await fetchProtocolCommitteeMeetingDates(payload)
  } catch (e) {
    console.error(e)
  }
}

/**
 *
 * @param context
 * @param payload
 * @returns {Promise<*>}
 */
const saveUCPCode = async(context, payload) => {
  try {
    const response = await saveUCPCodeProtocol(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

/**
 *
 * @param commit
 * @param payload
 * @returns {Promise<*>}
 */
const saveDictumFile = async({ commit }, payload) => {
  try {
    const response = await updateDictumFile(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

/**
 * Get protocol advances from server.
 *
 * @param commit
 * @param payload
 * @returns {Promise<*>}
 */
const getProtocolAdvances = async({ commit }, payload) => {
  try {
    const response = await fetchProtocolAdvances(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

/**
 *
 * @param commit
 * @param payload
 * @returns {Promise<*>}
 */
const getProtocolFinalReports = async({ commit }, payload) => {
  try {
    const response = await fetchProtocolFinalReports(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

/**
 *
 * @param commit
 * @param payload
 * @returns {Promise<*>}
 */
const getProtocolEthicsRenewal = async({ commit }, payload) => {
  try {
    const response = await fetchProtocolRenewals(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

/**
 *
 * @param commit
 * @param payload
 * @returns {Promise<*>}
 */
const getProtocolAdverseEvents = async({ commit }, payload) => {
  try {
    const response = await fetchProtocolAdverseEvents(payload)
    
    return response.data
  } catch (e) {
    console.error(e)
  }
}

/**
 *
 * @param commit
 * @param payload
 * @returns {Promise<*>}
 */
const getProtocols = async() => {
  try {
    const response = await fetchFunderOrigins()
    
    return response.data
  } catch (e) {
    console.error(e)
  }
}

const saveProtocolAdvances = async({ commit }, payload) => {
  try {
    return await saveAdvance(payload)
  } catch (e) {
    console.error(e)
  }
}

const deleteProtocol = async({ commit }, payload) => {
  try {
    return (await requestDeleteProtocol(payload))
  } catch (e) {
    console.error(e)
  }
}

const getFunderOrigins = async() => {
  try {
    const response = await fetchFunderOrigins()
    
    return response.data
  } catch (e) {
    console.error(e)
  }
}

const getFunderInstitutions = async() => {
  try {
    const response = await fetchFunderInstitutions()
    
    return response.data
  } catch (e) {
    console.error(e)
  }
}

const saveRequestedFunder = async({ commit }, payload) => {
  try {
    const response = await saveRequestedFunderInServer(payload)
    
    return response.data
  } catch (e) {
    console.error(e)
  }
}

export default {
  sendInviteReply,
  addResearcher,
  removeResearcher,
  removeExternalResearcher,
  saveLeaderEvaluation,
  saveDirectorEvaluation,
  getProtocolLeaderEvaluation,
  sendProtocolToEvaluation,
  resendInvitationNotification,
  resendExternalInvitationNotification,
  reinviteResearcher,
  reinviteExternalResearcher,
  saveProtocolFile,
  saveAmendmentFile,
  removeProtocolFile,
  removeAmendmentFile,
  getProtocolAttachments,
  saveProtocolAttachments,
  removeProtocolAttachment,
  saveProtocolFinancing,
  syncFunders,
  removeFunder,
  attachAgreementToFunder,
  getResearchLines,
  assignResearchLine,
  getProtocolFunders,
  requestProtocolDevelopment,
  updateProtocolRealDates,
  validateProtocolDevelopmentRequest,
  addFinancingCommitment,
  editFinancingCommitment,
  getFinancingCommitments,
  getFinancingCommitment,
  completeFinancinCommitment,
  rescheduleFinancinCommitment,
  completeFinancingExtensionCommitment,
  rescheduleFinancingExtensionCommitment,
  updateCompletedFinancingExtensionCommitment,
  updateRescheduledFinancingExtensionCommitment,
  getProtocolResearchers,
  removeResearchLine,
  renderBiosecurityQuestionnaire,
  saveBiosecurityQuestionnaire,
  removeCommitment,
  dictateDeleteCommitment,
  dictateDeleteFinancingExtensionCommitment,
  requestDeleteCommitment,
  requestDeleteFinancingExtensionCommitment,
  rpbiResearchers,
  sendInvitationByEmail,
  rejectResearcherInvitation,
  saveEthicsRenewalAttachments,
  removeEthicsRenewalAttachment,
  saveEthicsRenewalFormat,
  getEthicsRenewalAttachments,
  updateFunderInformation,
  updateCompletedFinancinCommitment,
  updateRescheduledFinancinCommitment,
  getEthicsRenewalDictums,
  saveEthicsRenewalDictum,
  saveFinalReportDictum,
  requestRemoveFinacingCommitment,
  requestRemoveFinacingExtensionCommitment,
  cancelProtocol,
  getProtocolEvaluations,
  getProtocolCommitteeDictums,
  getProtocolPendingTasks,
  getProtocolCommitteeAssignedReviewers,
  getProtocolCommitteeMeetingDates,
  saveUCPCode,
  saveDictumFile,
  getProtocolAdvances,
  getProtocolFinalReports,
  getProtocolEthicsRenewal,
  getProtocolAdverseEvents,
  getProtocols,
  respondConditioned,
  updateFinalReport,
  saveProtocolAdvances,
  deleteProtocol,
  getFunderOrigins,
  getFunderInstitutions,
  saveRequestedFunder,
}
